export default "__VITE_ASSET__CkcY_K4g__ 640w, __VITE_ASSET__CYGzEEqY__ 1024w, __VITE_ASSET__BEXIqb7X__ 1280w";